import { render, staticRenderFns } from "./budgetAnalysis.vue?vue&type=template&id=61e17376&"
import script from "./budgetAnalysis.vue?vue&type=script&lang=js&"
export * from "./budgetAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports